import assetPath from '/app/brewery-packages/xds/background-images/assets/Background_01_4x3_a.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')